import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import { Box, css } from '@mui/system';
import { colors } from 'theme/colors';

export const StyledLicenceWrapper = styled(Grid)`
  background-color: ${colors.gray100};
  border: 1px solid ${colors.gray200};
  border-radius: 4px;
  padding: 20px 20px 20px 32px;
  margin-bottom: 16px;
  row-gap: 12px;
  column-spacing: 12px;
`;

export const StyledPhoto = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.primary400};
  height: 320px;
  width: 270px;
`;

export const StyledDivider = styled(Box)`
  width: 100%;
  height: 1px;
  background-color: ${colors.gray300};
  margin: 0 0 16px 0;
`;

interface IStyledOwnerDetail {
  warning: boolean;
  label?: boolean;
}

export const StyledOwnerDetail = styled(Typography)<IStyledOwnerDetail>`
  ${(props: IStyledOwnerDetail) =>
    props.warning &&
    css`
      color: ${colors.success700};
      p {
        color: ${colors.success700};
      }
    `}
  ${(props: IStyledOwnerDetail) =>
    props.warning &&
    props.label &&
    css`
      &::after {
        content: '';
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-left: 4px;
        background-image: url("data:image/svg+xml;utf8,<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M2.66536 7.99998C2.66536 5.05446 5.05318 2.66665 7.9987 2.66665C10.9442 2.66665 13.332 5.05446 13.332 7.99998C13.332 10.9455 10.9442 13.3333 7.9987 13.3333C5.05318 13.3333 2.66536 10.9455 2.66536 7.99998ZM7.9987 1.33331C4.3168 1.33331 1.33203 4.31808 1.33203 7.99998C1.33203 11.6818 4.3168 14.6666 7.9987 14.6666C11.6806 14.6666 14.6654 11.6818 14.6654 7.99998C14.6654 4.31808 11.6806 1.33331 7.9987 1.33331ZM11.6368 6.30472L10.694 5.36191L7.33203 8.72385L5.4701 6.86191L4.52729 7.80471L7.33203 10.6094L11.6368 6.30472Z' fill='%23127858'/></svg>");
        background-repeat: no-repeat;
        background-size: contain;
        vertical-align: middle;
      }
    `}
`;

export const ImportFileContainer = styled(Grid)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 122px;
  row-gap: 12px;
  padding: 18px;
  border-width: 1px;
  border: 1px dashed ${colors.gray400};
  border-radius: 4px;
  &:hover {
    border-color: ${colors.primary400};
    background: ${colors.primary15};
  }
`;
